/**
* Global Middlewares
*/
export default defineNuxtRouteMiddleware(async (to, from) => {
  const { useCustomCookie } = useCustomTools()
  const { $member } = useNuxtApp()

  /*
  * Get Member
  * If it is necessary to first have the customer's data to render the page, then we add await to the request
  * (this is required for checkout, to interact correctly with checkout_hash)
  */
  if (to.path !== from.path && import.meta.client) {
    if (to.path.includes('/checkout') || to.path.includes('/customer')) {
      await $member.getMember()
    } else { 
      $member.getMember()
    }
  }

  /*
  * Disable/Enable Caching Requests
  */
  if (to.query['disable-cache'] === 'true' || to.query['disable-cache'] === '1') {
    useCustomCookie('disableCache').value = true
  } else if (to.query['disable-cache'] === 'false' || to.query['disable-cache'] === '0') {
    useCustomCookie('disableCache').value = false
  }

  /*
  * Referer
  */
  if (import.meta.client) {
    const referrer = useCustomCookie('referrer', 60 * 60 * 24 * 30)
    if (!referrer.value) {
      referrer.value = to.fullPath
    }
  }
})
